import { Drawer } from "antd";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

import "./menu.css";
import {
    aboutLink,
    contactLink,
    portfolioLinks,
    photographyLink,
    creatorPartnershipsLink,
    isPhotographyView,
    isCreatorPartnershipsView,
} from "../../navigation/navConfig";
import { useTranslation } from "../../../i18n";
import LanguageSwitcher from "../../LanguageSwitcher/LanguageSwitcher";
import { useWhiteLabel } from "../../../whiteLabel/useWhiteLabel";

function MenuIcon() {
    const [open, setOpen] = useState(false);
    const { pathname } = useLocation();
    const { t } = useTranslation();
    const { isWhiteLabel } = useWhiteLabel();

    const onClose = () => setOpen(false);

    return (
        <>
            <button
                type="button"
                className="menu-trigger"
                onClick={() => setOpen(true)}
                aria-label={t("common.menu")}
            >
                <svg
                    className="icon"
                    viewBox="0 0 1024 1024"
                    xmlns="http://www.w3.org/2000/svg"
                    width="1.2em"
                    height="1.2em"
                >
                    <path
                        d="M192.037 287.953h640.124c17.673 0 32-14.327 32-32s-14.327-32-32-32H192.037c-17.673 0-32 14.327-32 32s14.327 32 32 32zM192.028 543.17h638.608c17.673 0 32-14.327 32-32s-14.327-32-32-32H192.028c-17.673 0-32 14.327-32 32s14.327 32 32 32zM832.161 735.802H192.037c-17.673 0-32 14.327-32 32s14.327 32 32 32h640.124c17.673 0 32-14.327 32-32s-14.327-32-32-32z"
                        fill="#2c2c2c"
                    />
                </svg>
            </button>

            <Drawer
                width="16em"
                title={t("common.menu")}
                placement="right"
                onClose={onClose}
                open={open}
            >
                <div className="menu-language">
                    <LanguageSwitcher compact />
                </div>
                <ul className="menu-list">
                    {!isWhiteLabel && (
                        <li>
                            <Link
                                to={aboutLink.to}
                                onClick={onClose}
                                className={pathname === aboutLink.to ? "nav-link-active" : ""}
                            >
                                {t(aboutLink.labelKey)}
                            </Link>
                        </li>
                    )}
                    <li>
                        <Link
                            to={photographyLink.to}
                            onClick={onClose}
                            className={isPhotographyView(pathname) ? "nav-link-active" : ""}
                        >
                            {t(photographyLink.labelKey)}
                        </Link>
                        <ul className="menu-portfolio-list">
                            {portfolioLinks.map((link) => (
                                <li key={link.to} className="menu-portfolio-item">
                                    <Link
                                        to={link.to}
                                        onClick={onClose}
                                        className={pathname === link.to ? "nav-link-active" : ""}
                                    >
                                        {t(link.labelKey)}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </li>
                    <li>
                        <Link
                            to={creatorPartnershipsLink.to}
                            onClick={onClose}
                            className={isCreatorPartnershipsView(pathname) ? "nav-link-active" : ""}
                        >
                            {t(creatorPartnershipsLink.labelKey)}
                        </Link>
                    </li>
                    {!isWhiteLabel && (
                        <li className="menu-contact">
                            <Link
                                to={contactLink.to}
                                onClick={onClose}
                                className={pathname === contactLink.to ? "nav-link-active" : ""}
                            >
                                {t(contactLink.labelKey)}
                            </Link>
                        </li>
                    )}
                </ul>
            </Drawer>
        </>
    );
}

export default MenuIcon;
